import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-case-vehicle-form',
  templateUrl: 'form.component.html',
})
export class CaseVehicleFormComponent {
  @Input() public caseId: string;

  @Input() public type: string;

  @Input() model: any;

  public editorOptions = {
    placeholder: 'Enter your note...',
    modules: {
      toolbar: ['bold', 'link'],
    },
  };
}
